type Properties = {
    value: boolean | null;
    setValue: (value: boolean | null) => void;
    trueLabel: string;
    falseLabel: string;
    disabled?: boolean;
};

const leftValue = true;
const rightValue = false;

const ToggleSwitch = (props: Properties) => {
    const { value, setValue, trueLabel, falseLabel, disabled } = props;

    let leftClassName = 'field left';
    let rightClassName = 'field right';
    if (value === leftValue) {
        leftClassName += ' selected';
    } else if (value === rightValue) {
        rightClassName += ' selected';
    }

    const toggleClicked = (clickedValue: boolean) => {
        if (!disabled) {
            setValue(clickedValue);
        }
    };

    let style = {};
    if (disabled) {
        style = {
            filter: 'grayscale(1)'
        };
    }

    return <div 
        className="toggle-switch"
        style={style}
    >
        <div className={leftClassName} onClick={() => toggleClicked(leftValue)}>
            {trueLabel}
        </div>
        <div className={rightClassName} onClick={() => toggleClicked(rightValue)}>
            {falseLabel}
        </div>
    </div>;
};

export default ToggleSwitch;
